import { useState, useEffect, useRef } from "react";
import RenderCardCarrousel from "./renderCardCarrousel";
import CardCarrouselCategory from "./cardCarrouselCategory/cardCarrouselCategory";
/**
 * Componente reutilizable para el funcionamiento del carrousel
*/
export default function Carrousel({
  data = [],
  cardWidth,
  activeMomios,
  loading = true,
  classPrefix,
  classCarrousel,
  patrocinador,
  type,
  indexJson
}) {
  const sliderRef = useRef(null);
  // Estados para scroll y control de UI
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isEndReached, setIsEndReached] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);
  // Estados para control táctil y dimensiones
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [newWidth, setNewWidth] = useState(0);

  /** Detecta si el contenedor es scrollable al renderizar o redimensionar */
  useEffect(() => {
    const container = sliderRef.current;
    if (container) {
      setIsScrollable(container.scrollWidth > container.clientWidth);
    }
  }, [data, newWidth]);

  /** Detecta redimensionamiento de ventana */
  useEffect(() => {
    const onResize = () => setNewWidth(window.innerWidth);

    window.addEventListener('resize', onResize);
    return () => { window.removeEventListener('resize', onResize); };
  }, []);

  // Swipe táctil (izquierda / derecha)
  const handleTouchStart = (e) => setTouchStart(e.targetTouches[0].clientX);
  const handleTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const handleSwipe = () => {
    if (((touchStart - touchEnd) > 100) && currentIndex < data.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
    if (((touchEnd - touchStart) > 100) && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Manejo del scroll con botones left / right
  useEffect(() => {
    const container = sliderRef.current;
    if (!container) return;

    const onScroll = () => {
      setScrollLeft(container.scrollLeft);
      setIsEndReached(container.scrollLeft + container.clientWidth >= container.scrollWidth - 1);
    };

    container.addEventListener('scroll', onScroll);
    return () => {
      container.removeEventListener('scroll', onScroll);
      setNewWidth(container?.clientWidth);
    };
  }, [loading]);

  // Función para mover scroll del carrusel a traves de las flechas
  const moveScroll = (direction) => {
    const container = sliderRef.current;
    if (!container) return;

    const itemWidth = container.querySelector(`.${classCarrousel} > *`).clientWidth;
    const visibleItems = Math.floor(container.clientWidth / itemWidth);
    const scrollLeftNew = container.scrollLeft;

    const newScroll = direction === 'next'
      ? (Math.ceil(scrollLeftNew / itemWidth) + visibleItems) * itemWidth
      : (Math.floor(scrollLeftNew / itemWidth) - visibleItems) * itemWidth;

    container.scrollTo({ left: newScroll, behavior: 'smooth' });
  };

  return (
    <div className={`${classPrefix}__arrows`}>
      {/* Flecha izquierda si hay scroll */}
      {scrollLeft >= 1 && data.length > 0 && (
        <button type="button" className={`${classPrefix}__arrows-arrowL`} onClick={() => moveScroll("prev")} aria-label="Atrás" />
      )}

      {/* Contenedor carrousel deslizable */}
      <div className={`${classPrefix}__slider`} ref={sliderRef}>
        <div
          className={`${classPrefix}__slider-slides`}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleSwipe}
        >
          {data.map((item, index) => (
            <div className={`${classCarrousel}`} key={item.id_juego + "-" + index}>
              {type === 'category'
                ? <CardCarrouselCategory item={item} />
                : <RenderCardCarrousel item={item} flagMomios={activeMomios} patrocinador={patrocinador} indexJson={indexJson}/>
              }
            </div>
          ))}

        </div>
      </div>

      {/* Flecha derecha si hay scroll disponible */}
      {(isScrollable && !isEndReached && (((cardWidth * data?.length) >= newWidth))) && data.length > 0 && (
        <button type="button" className={`${classPrefix}__arrows-arrowR`} onClick={() => moveScroll("next")} aria-label="Adelante" />
      )}
    </div>
  )

}

